import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';
import { observer } from 'mobx-react';

export const GetFullVariantsQuery = gql`
  query($ids: [String!]) {
    completeVariants(where: { id_in: $ids }) {
      id
      ean
      sku
      definition
      price
      recommendedPrice
      product {
        id
        title
        name
        technicalSpecification
        subtitle
        variants {
          id
          ean
          sku
          definition
        }
        display
        status
        slug
        description
        price
        prices
        recommendedPrice
        tags
        weight
        weightForShipping
        images {
          id
          file
          priority
          createdAt
          values {
            id
          }
        }
      }
      attributeValues {
        id
        value
        title
        attribute {
          id
          isVisual
        }
      }
    }
  }
`;

interface IInputProps {
  children?: any;
  ids: Array<string>;
}

interface IResponse {
  data: any;
}

@observer
class VariantsQuery extends React.Component<ChildProps<IInputProps, IResponse>, {}> {
  public render() {
    const { fullVariants }: any = this.props;
    return this.props.children({
      fullVariants
    });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(GetFullVariantsQuery, {
    name: 'fullVariants',
    options: props => ({
      variables: {
        ids: props.ids
      }
    })
  })
)(VariantsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Products/FullFavoriteVariants.tsx